import { CALL_API } from 'middleware/api';
import * as Actions from '../index';

export function fetchVivoGamesToken() {
    return dispatch =>
        dispatch({
            type: Actions.FETCH_VIVO_GAMES_TOKEN,
            [CALL_API]: {
                endpoint: `/api/games-vivo/`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_VIVO_GAMES_TOKEN,
                    Actions.FAILURE_FETCH_VIVO_GAMES_TOKEN
                ]
            }
        });
}

export function fetchTvbetGamesToken() {
    return dispatch =>
        dispatch({
            type: Actions.FETCH_TVBET_GAMES_TOKEN,
            [CALL_API]: {
                endpoint: `/api/games-tvbet/`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_TVBET_GAMES_TOKEN,
                    Actions.FAILURE_FETCH_TVBET_GAMES_TOKEN
                ]
            }
        });
}

export function fetchFastsportToken() {
    return dispatch =>
        dispatch({
            type: Actions.FETCH_FASTSPORT_GAMES_TOKEN,
            [CALL_API]: {
                endpoint: `/api/games-tvbet/`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN,
                    Actions.FAILURE_FETCH_FASTSPORT_GAMES_TOKEN
                ]
            }
        });
}

export function fetchTvbetRoulletteToken() {
  return dispatch =>
        dispatch({
            type: Actions.FETCH_TVBET_ROULLETTE_TOKEN,
            [CALL_API]: {
                endpoint: `/api/games-tvbet/`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN,
                    Actions.FAILURE_FETCH_TVBET_ROULLETTE_TOKEN
                ]
            }
        });
}

export function fetchBetsolutionsGamesToken() {
    return dispatch =>
        dispatch({
            type: Actions.FETCH_BETSOLUTIONS_GAMES_TOKEN,
            [CALL_API]: {
                endpoint: `/api/games-betsolutions/`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_BETSOLUTIONS_GAMES_TOKEN,
                    Actions.FAILURE_FETCH_BETSOLUTIONS_GAMES_TOKEN
                ]
            }
        });
}

export function fetchVirtualSportsGamesToken() {
    return dispatch =>
        dispatch({
            type: Actions.FETCH_VIRTUAL_SPORTS_GAMES_TOKEN,
            [CALL_API]: {
                endpoint: `/api/games-virtual/`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN,
                    Actions.FAILURE_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN
                ]
            }
        });
}

export function getXpressGamesList(data) {
  return (dispatch) =>
    dispatch({
      type: Actions.FETCH_XPRESS_GAMES,
      [CALL_API]: {
        endpoint: `/api/games-xpress/games`,
        method: 'post',
        types: [Actions.SUCCESS_FETCH_XPRESS_GAMES, Actions.FAILURE_FETCH_XPRESS_GAMES],
        credentials: true,
        data,
      },
    })
}

export function joinXpressGame(gameId,data) {
  return dispatch =>
    dispatch({
      type: Actions.FETCH_XPRESS_TOKEN,
      [CALL_API]: {
        endpoint: `/api/games-xpress/join/${gameId}`,
        method: "post",
        types: [
          Actions.SUCCESS_FETCH_XPRESS_TOKEN,
          Actions.FAILURE_FETCH_XPRESS_TOKEN,
        ],
        credentials: true,
        data,
      }
    })
}

export function clearTvBetGamesError() {
  return dispatch => dispatch({type: Actions.CLEAR_TV_BET_ERROR});
}


export function getProviderXpressGames(){
    return dispatch =>
        dispatch({
            type: Actions.FETCH_PROVIDER_XPRESS_GAMES,
            [CALL_API]: {
                endpoint: `/api/games-xpress/providers`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_PROVIDER_XPRESS_GAMES,
                    Actions.FAILURE_FETCH_PROVIDER_XPRESS_GAMES
                ]
            }
        });
}

export function getTypesXpressGames(){
    return dispatch =>
        dispatch({
            type: Actions.FETCH_TYPE_XPRESS_GAMES,
            [CALL_API]: {
                endpoint: `/api/games-xpress/types`,
                method: "get",
                types: [
                    Actions.SUCCESS_FETCH_TYPE_XPRESS_GAMES,
                    Actions.FAILURE_FETCH_TYPE_XPRESS_GAMES
                ]
            }
        });
}

export function getPinnedXpressGames(data) {
  return (dispatch) =>
    dispatch({
      type: Actions.FETCH_PINNED_XPRESS_GAMES,
      [CALL_API]: {
        endpoint: `/api/games-xpress/gambler/${data.gamblerId}/pinned-games`,
        method: 'get',
        types: [Actions.SUCCESS_FETCH_PINNED_XPRESS_GAMES, Actions.FAILURE_FETCH_PINNED_XPRESS_GAMES],
      },
    })
}

export function updateXpressPinnedGames(gameId, isPinned) {
  return (dispatch) => dispatch({
    type: Actions.UPDATE_XPRESS_PINNED_GAMES,
    data: {gameId, isPinned},
  })
}


// WEBPACK FOOTER //
// ./js/actions/games/creators/index.js